module.exports = __webpack_public_path__ + "static/media/celebration-preview-mst.e9af47dd.svg";